<div class="shop-banner">
  <!--{{jobCard && jobCard.partner ? jobCard.partner.partnerName : ""}}-->
</div>

<div class="tab-menu" *ngIf="tabItems.length > 1">
  <div class="tab-menu-container">
    <div *ngFor="let item of tabItems" class="tab-item" [ngClass]="{'selected': item.view === selectedTab}"
         (click)="selectTabItem(item)">
      {{item.label}}
    </div>
  </div>
</div>


<div *ngIf="selectedTab === 'Messaging'">
  <div #scrollMe class="container center-container" *ngIf="!showInvoice">
    <div class="notification-container">
      <div class="invoice-content">
        <div class="invoice-company-info">
          <div style="width: 100%; display:flex;margin-bottom: 16px;">
            <span class="jobcard-header"
                  style="margin-right: 15px; line-height: 45px;">{{'cyclist.technician_name'| translate}}:</span>
            <span><avatar size=45 name="{{technicianName}}" profilePhoto="{{technicianPhoto}}"></avatar> </span>
            <span class="jobcard-header"
                  style="font-size: 95%;opacity: 0.9; margin-left: 10px; line-height: 45px;font-weight: 400;">{{technicianName}}</span>
          </div>
        </div>
      </div>
      <div class="no-messages" *ngIf="!loading && messages.length===0">{{ "cyclist.no_messages" | translate}}</div>
      <div class="notification" *ngFor="let notification of messages">
        <div [ngClass]="{'cyclist': notification.Direction==='Outgoing', 'bike-shop': notification.Direction==='Incoming'}">
          <div>{{notification.Message}}</div>
          <div class="date">{{notification.CreatedDate | date : 'medium'}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="message-footer" *ngIf="partner.length>0 && !showInvoice">
    <div class="jobcard-header">Jobcard: #{{jobcardno}}</div>
    <div class="row">
      <div class="col-md-12">
        <div class="p-inputgroup">
          <input type="text" pInputText [(ngModel)]="message"
                 placeholder="{{'bikeshop.modal.update_job_card.messaging.button.send_message' | translate }}"
                 [disabled]="sending"
                 (keyup.enter)="sendMessage()" />
          <span class="send-icon" (click)="sendMessage()" [ngClass]="{'sending': sending}"></span>
        </div>
      </div>
      <!-- <div class="col-12">
        <div class="find-out-more" [innerHTML]="'cyclist.find_out_more' | translate "></div>
      </div> -->
    </div>
  </div>
</div>

<div *ngIf="selectedTab === 'Job Card'" style="padding-top: 52px">
  <app-jobcard-invoices [serviceID]="jobcardId" [partnerID]="partnerId" [customerID]="athleteId"></app-jobcard-invoices>
</div>
<div *ngIf="selectedTab === 'Job Card Completed'" style="padding-top: 52px">
  <app-jobcard-invoices [serviceID]="jobcardId" [partnerID]="partnerId" [customerID]="athleteId" [allowRating]="true"></app-jobcard-invoices>
</div>
<div *ngIf="selectedTab === 'Attachments'" style="padding-top: 52px">
  <app-jobcard-attachments-phone [jobCardID]="jobcardId" [partnerID]="partnerId" [customerID]="athleteId"
                                 [qrCodeIdentifier]="jobCard.qrCodeIdentifier"></app-jobcard-attachments-phone>
</div>
<div *ngIf="selectedTab === 'Checklists'" style="padding-top: 52px">
  <app-jobcard-checklists [jobCardID]="jobcardId"></app-jobcard-checklists>
</div>

<div *ngIf="selectedTab === 'Approval'" style="padding-top: 52px">
  <app-jobcard-approval [jobCardID]="jobcardId"></app-jobcard-approval>
</div>


<div *ngIf="selectedTab === 'MultiQuoteApproval'" style="padding-top: 52px">
  <app-jobcard-multi-quote-approval [jobCardIdentifier]="jobCardIdentifier"></app-jobcard-multi-quote-approval>
</div>



